import request from '@/utils/request'

const PERMISSION_KEY = 'ops_permission_keys'
const USER_KEY = 'ops_user'

/**
 * 从后端拉取当前用户的 permission_key 列表并缓存到 localStorage
 * （网关解析 Cookie 中的 JWT → /user/permission/getPermissionKeyList）
 */
export async function fetchPermissionKeys() {
  try {
    const res = await request({
      url: '/user/permission/getPermissionKeyList',
      method: 'get'
    })
    const keys = Array.isArray(res) ? res : []
    localStorage.setItem(PERMISSION_KEY, JSON.stringify(keys))
    return keys
  } catch (e) {
    console.warn('[permission] fetch keys failed', e)
    return []
  }
}

export function getPermissionKeys() {
  try {
    return JSON.parse(localStorage.getItem(PERMISSION_KEY) || '[]')
  } catch {
    return []
  }
}

/**
 * 判断当前用户是否拥有指定权限：
 * - 未配置 permission 的资源默认可见（兼容旧逻辑）
 * - 管理员（sys_user.is_admin）直接放行
 */
export function hasPermission(key) {
  if (!key) return true
  try {
    const user = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
    if (user?.isAdmin) return true
  } catch { /* ignore */ }
  return getPermissionKeys().includes(key)
}

export function clearPermissions() {
  localStorage.removeItem(PERMISSION_KEY)
}
